/**
 * Frontend view script for Nucor Engineered Bar Steel School block.
 * Runs on the public-facing side of the site.
 */
document.addEventListener( 'DOMContentLoaded', () => {
	const blocks = document.querySelectorAll(
		'.wp-block-nc-tw-nucor-engineered-bar-steel-school'
	);

	blocks.forEach( ( block ) => {
		// Add frontend interactivity here.
		block.classList.add( 'is-initialized' );
	} );
} );
